import { AuthWellKnownEndpoints } from './auth-oidc-client/angular-auth-oidc-client';
import { OpenIDImplicitFlowConfiguration } from './auth-oidc-client/modules/auth.configuration';

export class CustomOIDC {
  CustomisedOidcConfig: OpenIDImplicitFlowConfiguration;
  CustomAuthWellKnownEndpoints: AuthWellKnownEndpoints;

  constructor(idpUrl: string, frontendUrl: string) {
    this.CustomisedOidcConfig = {
      stsServer: idpUrl,
      redirect_url: frontendUrl + '/content/auth-success.html',
      client_id: 'StoreFront',
      response_type: 'id_token token',
      scope:
        'openid profile IdentityServiceStoreFront OrderServiceStoreFront ProductsCommandServiceStoreFront ProductsQueryServiceStoreFront CartServiceStoreFront',
      post_logout_redirect_uri: frontendUrl + '/auth/post-logout',
      forbidden_route: frontendUrl + '/auth',
      unauthorized_route: frontendUrl + '/auth',
      log_console_warning_active: true,
      log_console_debug_active: false,
      max_id_token_iat_offset_allowed_in_seconds: 604800,
      silent_renew: true,
      silent_renew_offset_in_seconds: 30,
      silent_renew_url: frontendUrl + '/content/silent-renew.html',
      storage: localStorage,
      auto_userinfo: true,
      // no frontendurl! -> navigate to as relative path
      post_login_route: '/auth/post-login',
      resource: '',
      hd_param: '',
      start_checksession: false,
      auto_clean_state_after_authentication: true,
      trigger_authorization_result_event: false
    };

    this.CustomAuthWellKnownEndpoints = {
      authorization_endpoint: idpUrl + '/connect/authorize',
      token_endpoint: idpUrl + '/connect/token',
      userinfo_endpoint: idpUrl + '/connect/userinfo',
      revocation_endpoint: idpUrl + '/connect/revoke',
      jwks_uri: idpUrl + '/.well-known/openid-configuration/jwks',
      issuer: idpUrl,
      end_session_endpoint: idpUrl + '/connect/endsession',
      check_session_iframe: '',
      introspection_endpoint: '',

      setWellKnownEndpoints(data: any) {
        this.issuer = data.issuer;
        this.jwks_uri = data.jwks_uri;
        this.authorization_endpoint = data.authorization_endpoint;
        this.token_endpoint = data.token_endpoint;
        this.userinfo_endpoint = data.userinfo_endpoint;

        if (data.end_session_endpoint) {
          this.end_session_endpoint = data.end_session_endpoint;
        }

        if (data.check_session_iframe) {
          this.check_session_iframe = data.check_session_iframe;
        }

        if (data.revocation_endpoint) {
          this.revocation_endpoint = data.revocation_endpoint;
        }

        if (data.introspection_endpoint) {
          this.introspection_endpoint = data.introspection_endpoint;
        }
      }
    };
  }
}
